<template>
    <div class="model wxCard" >
        <img :src="
        userInfo.wxQrcodeCardUrl ?
        userInfo.wxQrcodeCardUrl :
        '../../../static/img/default.png'" alt="">
    </div>
</template>

<script>

export default {
  props: ['userInfo'],
  name: 'WxQrcodeCard'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wxCard {
    width: 3.43rem;
    height: 2.6rem !important;
    text-align: center;
}
.wxCard svg {
    margin-top: 35%;
}
.wxCard img {
    margin-top: .2rem;
    width: 2.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userDetailElement/WxQrcodeCard.vue